module.exports = __webpack_public_path__ + "9d1891098066d8e2bf1cfe715dcd2998.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-8@2x.png
// module id = 543
// module chunks = 0